import { Card, CardContent, Typography } from '@mui/material';
import styles from './MarketPlaceCard.module.css';
import PropTypes from 'prop-types';
function ServiceCard({ logo, name, onClick, category }) {
    return (
        <Card onClick={onClick} className={styles.card} elevation={1}>
            <CardContent className={styles.cardContent}>
                <img src={logo} alt={name} className={styles.logo} />
                <Typography className={styles.title}>{name}</Typography>
                <Typography className={styles.subTitle}>Category: {category}</Typography>
            </CardContent>
        </Card>
    );
}

export default ServiceCard;

ServiceCard.propTypes = {
    logo: PropTypes.string,
    name: PropTypes.string,
    onClick: PropTypes.func,
    category: PropTypes.string
};
